import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): ExperimentsState => {
  return {
    sworkitAd: null,
  };
};

const experiments = (
  state: ExperimentsState = getInitialState(),
  action: ActionTypes
): ExperimentsState => {
  switch (action.type) {
    case TypeKeys.SET_REMOTE_CONFIG_KEY: {
      return {
        ...state,
        [action.key]: action.value,
      };
    }
    case TypeKeys.SIGN_OUT: {
      return { ...getInitialState() };
    }
  }
  return state;
};

export default experiments;
